import { render, staticRenderFns } from "./tablePositionLevelGroup.vue?vue&type=template&id=68826cc0&scoped=true"
import script from "./tablePositionLevelGroup.vue?vue&type=script&lang=js"
export * from "./tablePositionLevelGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68826cc0",
  null
  
)

export default component.exports